import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISites } from '@df/core/df-core.interfaces';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NMultisiteSwitchModal {
    /**
     * Component id and block url
     */
    export const componentId = 'multisite-switch';

    /**
     * Multiste modal bLock
     */
    export type Block = ICmsBlock<IBlockData>;

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export interface IBlockDataContent {
        /**
         * Modal title
         */
        title: string;
        /**
         * Modal subtitle
         */
        subtitle?: string;
        /**
         * Close button subtitle
         */
        closeBtnCopy?: string;
        /**
         * Stores list
         */
        stores: IBlockContentStore[];
    }

    /**
     * Modal block content / store
     */
    export interface IBlockContentStore {
        // site id
        siteId: keyof ISites;
        // icon image
        icon?: string;
        //  name
        title: string;
    }
}
